module.exports = __webpack_public_path__ + "files/7b9f530286537a83baf5da5e092373ae.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/exo2-italic-webfont.woff
// module id = 676
// module chunks = 60